var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recent-invoices"},[_c('SectionTitle',{staticClass:"text-center",attrs:{"text":_vm.orderTitle}}),_vm._l((_vm.recentInvoices),function(invoice){return _c('RecentInvoice',{key:invoice.id,attrs:{"invoice":invoice}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }